'use client';
import { CUSTOMER_MENU } from '@shared/lib/constants';
import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function CustomerNavLinks() {
  const pathname = usePathname();
  return (
    <>
      {CUSTOMER_MENU.map((item) => (
        <li
          key={item.name}
          className="text-md text-bd-dark hover:bg-bd-secondary hover:text-bd-dark/80 rounded-md p-3 text-center"
        >
          <Link
            href={item.href}
            className={clsx('w-full', pathname === item.href ? 'underline' : '')}
          >
            {item.name}
          </Link>
        </li>
      ))}
    </>
  );
}
